// Safety In Design — checklist content (static app content, not business data).
// group 'general' = enabled by default ; group 'equipement' = optional (admin enables).

export const SID_SECTIONS = [
  { id: 'acces', title: 'Accès & plateformes', group: 'general', items: [
    { id: 'acces-a', label: 'Hauteur libre minimale (headroom)', ref: '2 100 mm (Asie) / 2 400 mm (autres)' },
    { id: 'acces-b', label: "Largeur d'accès minimale", ref: '800 mm' },
    { id: 'acces-c', label: 'Plinthes (toe plates) — hauteur minimale', ref: '150 mm' },
    { id: 'acces-e', label: 'Jeu sous plinthes', ref: '5 à 10 mm' },
    { id: 'acces-h', label: 'Garde-corps / plinthes sur toutes les plateformes, ouvertures, sommets de silos/équipements', ref: '' },
    { id: 'acces-i', label: 'Niveau de sol sans différence d\u2019altitude / marche isolée', ref: '' },
    { id: 'acces-j', label: 'Dégagement devant les équipements (dépoussiéreur, cyclone) pour retraite sûre', ref: '' },
  ] },
  { id: 'garde-corps', title: 'Garde-corps', group: 'general', items: [
    { id: 'gc-a', label: 'Nombre de lisses horizontales', ref: '3 lisses' },
    { id: 'gc-b', label: 'Hauteur minimale des montants', ref: '1 100 mm' },
    { id: 'gc-c', label: 'Espacement maximal des montants', ref: '1 200 mm (escaliers) / 1 500 mm (plateformes)' },
    { id: 'gc-e', label: "Continuité jusqu'à la voie d'évacuation", ref: '' },
    { id: 'gc-g', label: 'Portillons de sécurité auto-fermants (gravité)', ref: '' },
    { id: 'gc-h', label: 'Garde-corps amovibles : points d\u2019ancrage / ligne de vie', ref: '' },
  ] },
  { id: 'escaliers', title: 'Escaliers', group: 'general', items: [
    { id: 'esc-a', label: 'Largeur minimale des escaliers', ref: '800 mm' },
    { id: 'esc-b', label: 'Angle maximal des escaliers', ref: "39° avec l'horizontale" },
    { id: 'esc-c', label: 'Dénivelé max avant palier', ref: '18 marches' },
    { id: 'esc-e', label: 'Mains courantes des deux côtés', ref: '' },
    { id: 'esc-f', label: 'Plinthes des deux côtés et sur tous les paliers', ref: '' },
    { id: 'esc-h', label: 'Éclairage de sécurité (secouru)', ref: '' },
  ] },
  { id: 'echelles', title: 'Échelles à crinoline', group: 'general', items: [
    { id: 'ech-a', label: "Portillon de sécurité à l'arrivée", ref: '' },
    { id: 'ech-b', label: 'Volée : < 9 m simple, sinon paliers intermédiaires', ref: 'max 9 m/volée' },
    { id: 'ech-c', label: 'Crinoline de sécurité', ref: 'requise au-delà de 2,5 m' },
    { id: 'ech-d', label: 'Protection anti-chute arrière', ref: '' },
  ] },
  { id: 'portes', title: 'Portes & issues de secours', group: 'general', items: [
    { id: 'por-a', label: "Nombre minimal d'issues de secours", ref: '2 par bâtiment, issue à moins de 15 m' },
    { id: 'por-b', label: 'Barres anti-panique sur les issues de secours', ref: '' },
    { id: 'por-c', label: 'Signalétique lumineuse EXIT (secourue sur batterie)', ref: '' },
  ] },
  { id: 'ouvertures', title: 'Ouvertures de plancher', group: 'general', items: [
    { id: 'ouv-a', label: 'Protection contre les chutes (garde-corps)', ref: '' },
    { id: 'ouv-b', label: "Fermeture de l'ouverture (grille sous trappe)", ref: '' },
  ] },
  { id: 'protecteurs', title: 'Protecteurs (carters)', group: 'general', items: [
    { id: 'pro-a', label: 'Carters sur toutes les parties tournantes exposées', ref: '' },
    { id: 'pro-b', label: 'Retrait des carters uniquement à l\u2019aide d\u2019un outil', ref: '' },
    { id: 'pro-c', label: 'Graissage possible sans retirer le carter', ref: '' },
  ] },
  { id: 'surfaces-chaudes', title: 'Surfaces chaudes', group: 'general', items: [
    { id: 'sc-a', label: 'Protection (isolation ou grille) des surfaces > 50 °C accessibles', ref: '' },
  ] },
  { id: 'arret-urgence', title: "Arrêts d'urgence énergies", group: 'general', items: [
    { id: 'au-a', label: "Coupure d'urgence externe pour chaque énergie (eau, gaz, fuel, air comprimé…)", ref: '' },
  ] },
  { id: 'trappes-inspection', title: "Trappes d'inspection & de nettoyage", group: 'general', items: [
    { id: 'ti-a', label: "Trappes d'inspection/nettoyage sur tous les équipements concernés", ref: '' },
    { id: 'ti-b', label: 'Conception à ouverture rapide et à charnières', ref: '' },
    { id: 'ti-d', label: "Dimensions des trous d'homme", ref: '≥ 610 mm de diamètre' },
    { id: 'ti-f', label: "Trous d'homme de silos verrouillables avec consignes", ref: '' },
  ] },
  { id: 'levage', title: 'Moyens de levage', group: 'general', items: [
    { id: 'lev-a', label: 'Moyen de levage prévu pour tout équipement > 50 kg', ref: '' },
    { id: 'lev-b', label: 'Sur structure : monorails, points de levage, ponts roulants', ref: '' },
    { id: 'lev-c', label: 'Sur équipement : oreilles de levage > 50 kg', ref: '' },
  ] },
  { id: 'signaletique', title: 'Signalétique', group: 'general', items: [
    { id: 'sig-a', label: "Plaques d'avertissement bilingues (risques élec., EPI, interdiction de fumer…)", ref: '' },
    { id: 'sig-b', label: 'Pictogrammes standardisés', ref: '' },
  ] },
  { id: 'eclairage', title: 'Éclairage', group: 'general', items: [
    { id: 'ecl-a', label: 'Éclairage adéquat de tous les bâtiments et zones extérieures', ref: '' },
    { id: 'ecl-c', label: "Niveaux d'éclairement respectés par zone", ref: 'Prod. 200 lux, escaliers 150, passerelles 50, bureaux 500' },
  ] },
  { id: 'incendie', title: 'Détection & lutte incendie', group: 'general', items: [
    { id: 'inc-a', label: 'Détection incendie (centrale secourue ≥ 2 h, déclencheurs, annonciateurs)', ref: '' },
    { id: 'inc-b', label: 'Extincteurs dans locaux élec., CCR, local groupe de secours…', ref: '' },
  ] },
  { id: 'lignes-vie', title: "Lignes de vie & points d'ancrage", group: 'general', items: [
    { id: 'lv-a', label: 'Essais des lignes de vie / ancrages', ref: '2× la résistance de la ligne de vie' },
  ] },

  // ----- Sections ÉQUIPEMENTS (optionnelles, activées par l'admin) -----
  { id: 'convoyeurs', title: 'Convoyeurs (bande, chaîne, vis, élévateur)', group: 'equipement', items: [
    { id: 'conv-a', label: 'Carters sur parties tournantes et points rentrants (tambours, poulies, accouplements)', ref: '' },
    { id: 'conv-d', label: 'Dispositif anti-retour sur convoyeurs inclinés/verticaux', ref: '' },
    { id: 'conv-e', label: 'Arrêt coup-de-poing (câble/pull cord) des deux côtés', ref: '' },
    { id: 'conv-f', label: 'Tôle larmée sous les convoyeurs au-dessus des passages', ref: '' },
    { id: 'conv-be', label: 'Élévateur à godets : entraînement de pointage (inching) + hold-to-run', ref: '' },
  ] },
  { id: 'broyeurs', title: 'Broyeurs (vertical / à boulets / presse)', group: 'equipement', items: [
    { id: 'bry-a', label: 'Carter fixe autour de la virole (retrait par outil)', ref: '' },
    { id: 'bry-b', label: 'Plateforme d\u2019accès sûr au trou d\u2019homme du broyeur', ref: '' },
    { id: 'bry-c', label: 'Entraînement de pointage (inching) + hold-to-run', ref: '' },
    { id: 'bry-d', label: 'Panneau d\u2019avertissement système hydraulique haute pression', ref: '' },
  ] },
  { id: 'four', title: 'Four & préchauffeur', group: 'equipement', items: [
    { id: 'four-a', label: 'Ligne de vie sur toute la longueur du four + essais aux deux extrémités', ref: '' },
    { id: 'four-b', label: 'Alarme sonore manuelle avant démarrage de l\u2019inching', ref: '' },
    { id: 'four-c', label: 'Planchers/plateformes des 3 étages bas en tôle larmée ou béton', ref: '' },
    { id: 'four-d', label: 'Plinthes 200 mm autour des ouvertures (débourrage)', ref: '' },
    { id: 'four-e', label: 'Double évacuation en cas de trappe de débourrage', ref: '' },
  ] },
  { id: 'refroidisseur', title: 'Refroidisseur (cooler)', group: 'equipement', items: [
    { id: 'ref-a', label: 'Panneau d\u2019avertissement air blaster', ref: '' },
    { id: 'ref-b', label: 'Ventilation des zones confinées (hydraulique, extraction clinker)', ref: '' },
    { id: 'ref-c', label: 'Carter fixe (retrait par outil)', ref: '' },
    { id: 'ref-e', label: 'Voyants en verre sécurité (résistant aux projections)', ref: '' },
  ] },
  { id: 'air-comprime', title: 'Air comprimé (réservoirs, blasters)', group: 'equipement', items: [
    { id: 'ac-a', label: 'Soupape de sûreté + manomètre sur chaque réservoir', ref: '' },
    { id: 'ac-b', label: 'Air blaster retenu par câble de sécurité', ref: '' },
    { id: 'ac-c', label: 'Vanne d\u2019isolement verrouillable + purge manuelle', ref: '' },
    { id: 'ac-d', label: 'Trou d\u2019homme pour réservoir > 900 mm de diamètre', ref: '' },
  ] },
  { id: 'ponts-roulants', title: 'Ponts roulants / palans', group: 'equipement', items: [
    { id: 'pr-a', label: 'Dispositif de surcharge (coupure si charge > CMU)', ref: '' },
    { id: 'pr-b', label: 'Linguet de sécurité sur le crochet', ref: '' },
    { id: 'pr-c', label: 'Fins de course haut/bas et translation', ref: '' },
    { id: 'pr-d', label: 'CMU marquée + essais et certification', ref: '' },
    { id: 'pr-e', label: 'Arrêt d\u2019urgence sur la télécommande', ref: '' },
  ] },
];
